/**
 * JK | Mega menu — opens the desktop panel on hover (with a short intent delay),
 * on click/tap, and from the keyboard. Esc, the scrim, or leaving the panel closes it.
 * In the theme editor, selecting one of its blocks pins it open.
 */
if (!customElements.get('jk-mega-menu')) {
  customElements.define(
    'jk-mega-menu',
    class JkMegaMenu extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector('.jk-mega__trigger');
        this.panel = this.querySelector('.jk-mega__panel');
        this.scrim = this.querySelector('.jk-mega__scrim');
        this.timer = null;
        this.openedByHover = false;
        this.pinned = false;

        const hoverIn = (event) => {
          if (event.pointerType !== 'mouse') return;
          this.schedule(() => this.open(true), this.hasAttribute('open') ? 0 : 90);
        };
        const hoverOut = (event) => {
          if (event.pointerType !== 'mouse' || this.pinned) return;
          this.schedule(() => this.close(), 220);
        };

        this.trigger.addEventListener('pointerenter', hoverIn);
        this.panel.addEventListener('pointerenter', hoverIn);
        this.trigger.addEventListener('pointerleave', hoverOut);
        this.panel.addEventListener('pointerleave', hoverOut);

        this.trigger.addEventListener('click', () => {
          // A mouse click right after hover-open shouldn't snap it shut again
          if (this.hasAttribute('open') && this.openedByHover) {
            this.openedByHover = false;
            return;
          }
          this.hasAttribute('open') ? this.close() : this.open(false);
        });

        this.scrim.addEventListener('click', () => this.close());

        this.addEventListener('keydown', (event) => {
          if (event.key !== 'Escape' || !this.hasAttribute('open')) return;
          this.close();
          this.trigger.focus();
        });

        this.addEventListener('focusout', (event) => {
          if (!this.contains(event.relatedTarget) && !this.pinned) this.close();
        });

        document.addEventListener('shopify:block:select', (event) => {
          if (!this.panel.contains(event.target)) return;
          this.pinned = true;
          this.open(false);
        });
        document.addEventListener('shopify:block:deselect', (event) => {
          if (!this.panel.contains(event.target)) return;
          this.pinned = false;
          this.close();
        });
      }

      schedule(fn, delay) {
        clearTimeout(this.timer);
        this.timer = setTimeout(fn, delay);
      }

      open(byHover) {
        clearTimeout(this.timer);
        if (this.hasAttribute('open')) return;
        this.openedByHover = byHover;
        // Close the theme's own dropdowns so two menus never overlap
        document.querySelectorAll('header-menu details[open]').forEach((details) => details.removeAttribute('open'));
        this.setAttribute('open', '');
        this.trigger.setAttribute('aria-expanded', 'true');
      }

      close() {
        clearTimeout(this.timer);
        this.openedByHover = false;
        this.removeAttribute('open');
        this.trigger.setAttribute('aria-expanded', 'false');
      }
    }
  );
}
